import { TenantConfigViewItem } from 'src/dao/tenantConfigClient';
import { OptionGroup, Option } from 'src/components/Configure/ConfigureModal';
import { pick, compact, cloneDeep } from 'lodash';
import { Indexable } from 'src/types/Primitive';

export interface ParseResult {
  optionGroups: OptionGroup[];
  defaultSelections: Option[];
  originalDefaultSelections: Option[];
  instructions?: string;
  minimumSelections?: number;
  includeAggBys: boolean;
}

export interface Parseable {
  main?: {
    info?: string;
    minimumSelections?: number;
    includeAggBys?: boolean;
  };
  defaults?: Indexable;
  view?: TenantConfigViewItem[];
  defaultsOverride?: Option[];
}

export function parseConfigureConfig(config: Parseable, defaults?: Indexable): ParseResult {
  const optionGroupConfigs = config.view || [];
  const defaultLookup = defaults || config.defaults || {};
  const defaultOptions = {
    dataIndex: '',
    text: '',
  };
  // Configure Grouping
  const optionGroups = optionGroupConfigs.map((group) => ({
    text: group.text,
    options: group.view || [defaultOptions],
  }));

  let defaultSelections = compact(
    optionGroupConfigs.map((group) => {
      const defaultKey = defaultLookup[group.dataIndex];

      if (defaultKey && group.view) {
        for (const child of group.view) {
          if (child.dataIndex === defaultKey) {
            // types Option and TenantConfigViewItem do not overlap quite right
            // coercing to Option to prevent mismatch type issues related to optional text properties
            const picked = pick(child, 'dataIndex', 'text', 'renderer') as Option;
            return picked;
          }
        }
        throw new Error(`Default config item "${defaultKey}" not found in children`);
      }
      return undefined;
    }),
  );
  const originalDefaultSelections = cloneDeep(defaultSelections);
  if (config.defaultsOverride) {
    defaultSelections = config.defaultsOverride;
  }

  return {
    instructions: config.main && config.main.info,
    minimumSelections: config.main && config.main.minimumSelections,
    includeAggBys: config.main?.includeAggBys ?? false,
    optionGroups,
    defaultSelections,
    originalDefaultSelections,
  };
}
